export default function interval(fn, delay) {
	let intervalId = setInterval(fn, delay);

	return {
		stop() {
			clearInterval(intervalId);
			intervalId = null;
		}
	};
}
